type Primitive = number | string;

export default function groupByFn<T extends { [key: string]: any }, K extends Primitive>(array: T[], getValue: (item: T) => K): Map<K, T[]> {
    return array.reduce(
        (grouped: Map<K, T[]>, current: T) => {
            const attrValue = getValue(current);
            if (!grouped.has(attrValue)) {
                grouped.set(attrValue, []);
            }
            grouped.get(attrValue)!.push(current);

            return grouped;
        },
        new Map(),
    );
}
